import { select, call, put } from "redux-saga/effects";
import { callAPI, METHODS } from "./apiSaga";
import {
  getMDLDataDone,
  getListMultiZip,
  addConversion,
  processConversion,
  getConversionStatus,
  updateStoreConversionStatus,
  updateStoreConversionStatusDescription,
  updateConversionStatus,
} from "../actions/actions";

const ConversionTimeOut = 600;
const ConversionTimeOutFake = 600;
function isJson(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}
const REACT_APP_FETCH_CONFIG =
  window.process !== undefined ? window.process.env.REACT_APP_FETCH_CONFIG : process.env.REACT_APP_FETCH_CONFIG;
const REACT_APP_FETCH_CONFIG_OUT =
  window.process !== undefined ? window.process.env.REACT_APP_FETCH_CONFIG_OUT : process.env.REACT_APP_FETCH_CONFIG_OUT;
const REACT_APP_FETCH_SUBSCRIPTION =
  window.process !== undefined
    ? window.process.env.REACT_APP_FETCH_SUBSCRIPTION
    : process.env.REACT_APP_FETCH_SUBSCRIPTION;
const REACT_APP_PATTERN_ASSISTANT =
  window.process !== undefined
    ? window.process.env.REACT_APP_PATTERN_ASSISTANT
    : process.env.REACT_APP_PATTERN_ASSISTANT;

const REACT_APP_FETCH_CONFIG_OUT2 =
  window.process !== undefined
    ? window.process.env.REACT_APP_FETCH_CONFIG_OUT2
    : process.env.REACT_APP_FETCH_CONFIG_OUT2;
let u = "0";
function sleep(milliseconds) {
  const date = Date.now();
  let currentDate = null;
  do {
    currentDate = Date.now();
  } while (currentDate - date < milliseconds);
}
export function* ProcessConversion(action) {
  //console.log("ProcessConversion");
  let url;
  if (action.payload.conversion.type === "mdl") url = REACT_APP_FETCH_CONFIG_OUT;
  else url = REACT_APP_FETCH_CONFIG; // ==="accumark" OR "astm aama"

  var body = new FormData();
  if (action.payload.fileexist === false) body.append("UseLoadedFile", action.payload.conversion.datain);
  else {
    if (action.payload.conversion.type === "mdl") body.append("MDLfile", action.payload.file);
    else body.append("EXFfile", action.payload.file);
  }

  if (action.payload.arrrulfiles !== undefined) {
    if (action.payload.arrrulfiles[0] !== undefined) body.append("RULfile", action.payload.arrrulfiles[0]);
    if (action.payload.arrrulfiles[1] !== undefined) body.append("RULfile", action.payload.arrrulfiles[1]);
    if (action.payload.arrrulfiles[2] !== undefined) body.append("RULfile", action.payload.arrrulfiles[2]);
    if (action.payload.arrrulfiles[3] !== undefined) body.append("RULfile", action.payload.arrrulfiles[3]);
  }
  body.append("ToCADStorage", true);
  body.append("ConverterId", action.payload.conversion.converter);
  body.append("ConverterType", action.payload.conversion.type);
  //De momento, lo enviamos para los dos. Debemos verificar eu en In (que siempre será mdl) va todo bien
  if (action.payload.conversion.typeOut === "mdl_V7") body.append("ConverterTypeOut", "mdlv7");
  else body.append("ConverterTypeOut", action.payload.conversion.typeOut);
  //body.append("ConverterTypeOut", "mdlv7");

  body.append("ConversionUniqueId", action.payload.conversion.id);

  var method = METHODS.POST;
  sleep(50);
  //console.log(body.get("RULfile"));
  const { success } = yield call(callAPI, { url, method, body });

  if (success) {
    //let status="sent";
  }
}

export function* PreProcessConversion(action) {
  const url = REACT_APP_FETCH_CONFIG + "-multiple/";

  var body = new FormData();
  body.append("MultipleMdlFile", action.payload.file);
  let user = action.payload.user;
  let converterId = action.payload.converterId;
  let convertertype = action.payload.convertertype;

  var method = METHODS.POST;

  const { success } = yield call(callAPI, { url, method, body });

  if (success) {
    const filename = action.payload.file.name;
    yield put(getListMultiZip({ filename, user, converterId, convertertype }));
  }
}

export function* GetListMultiZip(action) {
  const multiZipfilename = "M_" + action.payload.filename;
  let filename = action.payload.filename;
  let user = action.payload.user;
  let converterId = action.payload.converterId;
  let convertertype = action.payload.convertertype;

  const url = REACT_APP_FETCH_CONFIG + "-multiple/listzip/" + multiZipfilename + "/" + filename;

  const { success, result } = yield call(callAPI, { url });
  if (success) {
    //when uri is received, it's neccesary:
    // 1.-get the file names (more than one)
    let listFileName = result;
    let arrFileName = listFileName.split("||");
    let arrConversions = [];

    for (let i = 0; i < arrFileName.length; i++) {
      let fileFromArray = arrFileName[i];

      //arrFileName.forEach(fileFromArray => {
      // 2.-for each file, create a conversion object

      if (fileFromArray !== "") {
        //yield call(ConvertUniqueFile(fileFromArray, user, converterId, convertertype));
        //let UniqueId = Date.now().toString();
        let DateNow = Date.now().toString();
        let UniqueId = DateNow + "_" + fileFromArray;
        const extension = fileFromArray.split(".").pop();

        //to have different id when multidrop
        let date = new Date(parseInt(DateNow, 10));

        let fdate = new Intl.DateTimeFormat("en-GB", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        }).format(date);
        const dataout = fileFromArray.replace("." + extension, ".mdl");

        let conversion = {
          id: UniqueId,
          date: fdate,
          user: user,
          datain: fileFromArray,
          dataout: dataout,
          converter: converterId,
          type: convertertype,
          status: "Sent",
        };
        arrConversions.push(conversion);
        yield put(addConversion(conversion));
        let fileexist = false;
        yield put(processConversion({ fileexist, conversion }));
      }
    }
  }
}

export function* GetConversionStatus(action) {
  //Ask gateway conversion status
  //alert("GetConversionStatus");
  console.log("###############GetConversionStatus##############");
  let urlbase;
  if (action.payload.type === "mdl") urlbase = REACT_APP_FETCH_CONFIG;
  //urlbase = REACT_APP_FETCH_CONFIG_OUT;
  else urlbase = REACT_APP_FETCH_CONFIG; // ==="accumark" OR "astm aama"

  const url = urlbase + "/status/" + action.payload.id + "/" + action.payload.type;

  const { success, result } = yield call(callAPI, { url });
  if (success) {
    sleep(10);
    let status = result.status;
    let description = result.description;

    if (status !== "Not found") {
      if (status === "OnGoing") status = "in_convertion";
      if (status === "Error on CAD Data send") status = "Error_on_CAD_Data_send";
      if (status === "Failure") status = "ko";
      //Update status on redux store
      yield put(updateStoreConversionStatus({ id: action.payload.id, status }));
      yield put(
        updateStoreConversionStatusDescription({
          id: action.payload.id,
          status,
          description,
        }),
      );
    }
    yield put(updateConversionStatus(action.payload.id));
  }
}

export function* StartAskingConversionStatus() {
  //create and start the timer
  /* At the mommnet, it is not possible to call a function (generator function) in this way...we have to learn...
  let interval = 3000;
  let Timer = setInterval(AskStatus, interval);
  */
}
export function* StopAskingConversionStatus(CurrentTimer) {
  let timer = CurrentTimer.payload;
  clearInterval(timer);
}
export function* GetMDLData(action) {
  let viewMDLData = document.getElementById("View_" + action.payload.id);
  if (viewMDLData != null) {
    viewMDLData.style.visibility = "visible";
    viewMDLData.style.opacity = "0.4";
    viewMDLData.classList.add("BuildingDataView");
  }

  yield put(getMDLDataDone({}));
  const url = REACT_APP_FETCH_CONFIG + "-mdl/data/" + action.payload.dataout + "/" + action.payload.datain;

  const { success, result } = yield call(callAPI, { url });
  let MDLData = {};
  if (success) {
    MDLData = isJson(result) ? JSON.parse(result) : {};
    yield put(getMDLDataDone(MDLData));
    if (action.payload.bopenMDLViewer === "true") {
      let MDLViewer = document.getElementById("MDLViewer");
      MDLViewer.style.display = "flex";
    } else {
      if (viewMDLData != null) {
        viewMDLData.setAttribute("bopenmdlviewer", true);
      }
    }
  } else {
  }

  viewMDLData.style.opacity = "1";
  viewMDLData.classList.remove("BuildingDataView");
}

export function* DownLoadMDL(action) {
  const url = REACT_APP_FETCH_CONFIG + "-mdl/urimdl/" + action.payload.id;

  const { success, result } = yield call(callAPI, { url });

  if (success) {
    let MDLUri = isJson(result) ? JSON.parse(result) : {};
    let button_urimdl = document.getElementById("urimdl_" + action.payload.id);
    let urimdl = MDLUri.uri;
    button_urimdl.setAttribute("href", urimdl);
    button_urimdl.click();
  }
  let download = document.getElementById("DownLoad_" + action.payload.id);
  download.classList.remove("downloading");
  download.classList.add("download");
}
export function* ShowMDLInPatternAssistant(action) {
  /////////////// We get the VersionId and DocumentId
  let url = REACT_APP_FETCH_CONFIG + "-mdl/urimdl/" + action.payload.id;

  let { success, result } = yield call(callAPI, { url });
  let urimdl;
  let urimdlVersionId;
  let urimdlDocumentId;
  let context = "patternconverter";
  let Entorno = "dev";
  if (success) {
    let MDLUri = isJson(result) ? JSON.parse(result) : {};
    let button_urimdl = document.getElementById("urimdl_" + action.payload.id);
    urimdl = MDLUri.uri;
    urimdlVersionId = MDLUri.versionId;
    urimdlDocumentId = MDLUri.documentId;

    let PADirOne = REACT_APP_PATTERN_ASSISTANT;
    PADirOne = PADirOne.replace("[ENV]", Entorno);
    PADirOne = PADirOne.replace("[CONTEXT]", context);
    PADirOne = PADirOne.replace("[DOCID]", urimdlDocumentId);
    PADirOne = PADirOne.replace("[VERSIONID]", urimdlVersionId);
    window.open(PADirOne);

    //////////////// We see if there are variants
    /*
    url = REACT_APP_FETCH_CONFIG + "-mdl/data/" + action.payload.dataout + "/" + action.payload.datain;

    let algo = yield call(callAPI, { url });
    let success2 = algo.success;
    let result2 = algo.result;
    let MDLData = {};
    let nVariantesNumber;
    let Variantes = [];
    if (success2) {
      MDLData = isJson(result2) ? JSON.parse(result2) : {};
      nVariantesNumber = MDLData.VariantesNumber;
      let i = 0;
      while (i < nVariantesNumber) {
        Variantes[i] = MDLData.Variantes[i];
        let VarName = Variantes[i].Name;
        /// Launch Pattern Assitant on a new window

        let PADir = REACT_APP_PATTERN_ASSISTANT_VARIANTS;

        PADir = PADir.replace("[ENV]", Entorno);
        PADir = PADir.replace("[CONTEXT]", context);
        PADir = PADir.replace("[DOCID]", urimdlDocumentId);
        PADir = PADir.replace("[VERSIONID]", urimdlVersionId);
        PADir = PADir.replace("[VARNAME]", VarName);
        //alert(PADir);
        window.open(PADir);
        i++;
      }
    } else {
    }*/
  }

  ////////////// Launching the Pattern Assistant
}
export function* UpdateConversionStatus(conversionid) {
  // This function set and modify the user interface  according the status given by the gateway and stored in the store
  let conversion;
  // get conversions from store
  let conversions = yield select((state) => state.conversions);
  for (let i = 0; i < conversions.length; i++) {
    if (conversionid.payload == conversions[i].id) {
      conversion = conversions[i];
      break;
    }
  }
  let Converter = document.getElementById("uploadzone" + conversion.converter);
  //if current status is Done or timeOut or ko, stop
  if (
    conversion.status === "Done" ||
    conversion.status === "TimeOut" ||
    conversion.status === "ko" ||
    conversion.status === "Error_on_CAD_Data_send"
  ) {
    if (conversion.status === "Done") {
      const extension = conversion.dataout.split(".").pop();
      if (extension === "mdl") {
        let viewMDLData = document.getElementById("View_" + conversion.id);
        if (viewMDLData != null) {
          viewMDLData.style.visibility = "visible";
          viewMDLData.style.opacity = "0.4";
          viewMDLData.setAttribute("bopenmdlviewer", false);
        }
        //We only show the eye of Pattern assistant if it is an import to a mdl
        /*
        if (conversion.typeOut === "mdl") {
          let viewMDLDataPatternAssintant = document.getElementById("ViewPatternAssistant_" + conversion.id);
          if (viewMDLDataPatternAssintant != null) {
            console.log(viewMDLDataPatternAssintant);
            if (viewMDLDataPatternAssintant != undefined) viewMDLDataPatternAssintant.style.visibility = "visible";
          }
        }*/
      }
      let downMDL = document.getElementById("DownLoad_" + conversion.id);
      if (downMDL !== null) downMDL.style.visibility = "visible";
    }

    // Process is finished ; Done, TimeOut, ko, or Error_on_CAD_Data_send

    return false;
  }

  //let processingTime = (Date.now() - parseInt(conversion.id, 10)) / 1000;
  let idData = conversion.id.split("_");
  let startDate = idData[0];
  let processingTime = (Date.now() - parseInt(startDate, 10)) / 1000;
  if (processingTime > ConversionTimeOut) {
    // Process is Timeout: Stopped
    // all states are set by the gateway, but not the timeout; that is set by the frontend (Pattern Converter)

    yield put(updateStoreConversionStatus({ id: conversion.id, status: "TimeOut" }));
    yield put(
      updateStoreConversionStatusDescription({
        id: conversion.id,
        status: "TimeOut",
        description: "TimeOut",
      }),
    );
  } else {
    // Process is still ongoing
    //Converter.classList.add("processing");
    //Converter.classList.remove("stopped");

    let UploadZoneInnerBox = document.getElementById("uploadzoneinnerbox" + conversion.converter);
    UploadZoneInnerBox.classList.add("processing");
    UploadZoneInnerBox.classList.remove("stopped");
  }
}
